// 追尾の購入ボタン表示----------------------


//スクロールした際の動きを関数でまとめる
function setFadeElement(){
  var windowH = $(window).height(); //ウィンドウの高さを取得
  var scroll = $(window).scrollTop(); //スクロール値を取得

    //出現範囲の指定
  var contentsTop = Math.round($('.column-main').offset().top);  //要素までの高さを四捨五入した値で取得
  var contentsH = $('.column-main').outerHeight(true); //要素の高さを取得



    //出現範囲内に入ったかどうかをチェック
  if(scroll+windowH >= contentsTop && scroll+windowH  <= contentsTop+contentsH){
    $("#buy-now-button").addClass("LeftMove");    //入っていたらLeftMoveをクラス追加
    $("#buy-now-button").removeClass("RightMove");   //RightMoveを削除
    $(".hide-btn").removeClass("hide-btn");   //hide-btnを削除
  }
    else{
        if(!$(".hide-btn").length){       //サイト表示時にRightMoveクラスを一瞬付与させないためのクラス付け。hide-btnがなければ下記の動作を行う
      $("#buy-now-button").addClass("RightMove");  //RightMoveをクラス追加
      $("#buy-now-button").removeClass("LeftMove"); //LeftMoveを削除
    }
  }
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  setFadeElement();/* スクロールした際の動きの関数を呼ぶ*/
});

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  setFadeElement();/* スクロールした際の動きの関数を呼ぶ*/
});


// #buy-now-buttonをクリックした際の設定
$('#buy-now-button').click(function () {
    $('body,html').animate({
        scrollTop: 0//ページトップまでスクロール
    }, 500);//ページトップスクロールの速さ。数字が大きいほど遅くなる
    return false;//リンク自体の無効化
});